import { z } from "zod";

export const SetterSchema = z.object({
	setter: z.string()
});

export type Setter = z.infer<typeof SetterSchema>;
